import Vue from 'vue'
import Vuex from 'vuex'
import getters from './getters'

Vue.use(Vuex);
// https://webpack.js.org/guides/dependency-management/#requirecontext
// require.context
// 您可以使用require.context()函数创建自己的上下文。
// 它允许您传递要搜索的目录，指示是否也应搜索子目录的标志以及用于匹配文件的正则表达式。
// require.context()在构建时，webpack 在代码中进行解析
// 语法如下：require.context(directory, useSubdirectories = true, regExp = /^\.\/.*$/, mode = 'sync');
 
const modulesFiles = require.context('./modules', true, /\.js$/) // 搜索modules文件夹下的js文件
// you do not need `import app from './modules/app'`
// it will auto require all vuex module from modules file
const modules = modulesFiles.keys().reduce((modules, modulePath) => {
  // set './app.js' => 'app'
  const moduleName = modulePath.replace(/^\.\/(.*)\.\w+$/, '$1')
  const value = modulesFiles(modulePath)
  modules[moduleName] = value.default
  return modules
}, {})
const store = new Vuex.Store({
  modules,
  getters
});

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js